import React from "react";
import { getWalletFlatRechargeComponent } from "@/pages/wallet/strategy/walletStrategy";

const FlatRecharge = () => {
  const Component = getWalletFlatRechargeComponent();
  return <Component />;
};

export default FlatRecharge;
